import { FC, lazy } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';

// types
import { PdpRespSimilarAuctionItemsLazy_user$key } from './__generated__/PdpRespSimilarAuctionItemsLazy_user.graphql';
import { PdpRespSimilarAuctionItemsLazy_viewer$key } from './__generated__/PdpRespSimilarAuctionItemsLazy_viewer.graphql';

export const PdpRespSimilarAuctionItemsLazyComponent = lazy(
    () =>
        import(/* webpackChunkName: "PdpRespSimilarAuctionItems" */ './PdpRespSimilarAuctionItems')
);

const userFragment = graphql`
    fragment PdpRespSimilarAuctionItemsLazy_user on User {
        ...PdpRespSimilarAuctionItems_user
    }
`;

const viewerFragment = graphql`
    fragment PdpRespSimilarAuctionItemsLazy_viewer on Viewer {
        ...PdpRespSimilarAuctionItems_viewer
    }
`;

export const PdpRespSimilarAuctionItemsLazy: FC<{
    user: PdpRespSimilarAuctionItemsLazy_user$key;
    viewer: PdpRespSimilarAuctionItemsLazy_viewer$key;
    currency: string;
}> = ({ user: userRef, viewer: viewerRef, currency }) => {
    const user = useFragment(userFragment, userRef);
    const viewer = useFragment(viewerFragment, viewerRef);

    return (
        <ClientSuspense fallback={null}>
            <PdpRespSimilarAuctionItemsLazyComponent
                user={user}
                viewer={viewer}
                currency={currency}
            />
        </ClientSuspense>
    );
};
